import { render, staticRenderFns } from "./InsertionOrderShow.vue?vue&type=template&id=54c94ef6&"
import script from "./InsertionOrderShow.vue?vue&type=script&lang=js&"
export * from "./InsertionOrderShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports